module.exports = __webpack_public_path__ + "static/img/right.abfc2d26.png";